import { Box, Button, FormControl, MenuItem, Select, Typography } from '@mui/material'
import React from 'react'
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import ExcelExportToolbar from './ExcelExportToolbar';
import { getExtraReportColumns } from './extraReportColumns';
import { useMemo, useState } from 'react';
import { FaEye } from "react-icons/fa";
import Sikayet_View from '../modals/Sikayet_View';
import InputLabel from '@mui/material/InputLabel';
import { MdEdit } from "react-icons/md";
import ActionType_Modal from '../modals/ActionType_Modal';
import { MdDeleteForever } from "react-icons/md";
import Delete_Modal from '../modals/Delete_Modal';

const RamakKala_Table = ({ ramakkala, handleClose_ramakkala, handleOpen_ramakkala, open_ramakkala, handleOpen_action, handleClose_action, open_action, handleOpen_delete, handleClose_delete, open_delete, showExtra = false }) => {

    const [info, setInfo] = useState({
        name: "",
        phone: "",
        email: "",
        gorev: "",
        eventType: "",
        birim: "",
        location: "",
        yerZaman: "",
        ramakkaladetay: "",
        oneri: "",
        actionType: "",
        actionResult: "",
        bonnaUser: "",
        datetime: ""

    })

    const defaultColumns = useMemo(() => [
        { field: "id", headerName: "ID", minWidth: 150, headerAlign: "center", align: "center", flex: 1, disableExport: true },
        {
            field: "actions",
            headerName: "Aksiyon",
            minWidth: 100,
            headerAlign: "center",
            align: "center",
            flex: 1,
            disableExport: true,
            renderCell: ({
                id,
                row: {
                    name,
                    surname,
                    phone,
                    email,
                    gorev,
                    eventType,
                    birim,
                    location,
                    yerZaman,
                    ramakkaladetay,
                    oneri,
                    actionType,
                    actionResult,
                    bonnaUser,
                    datetime
                }
            }) => [
                    <GridActionsCellItem
                        key="edit"
                        label="Edit"
                        icon={<MdEdit size={23} style={{ cursor: 'pointer', color: '#E8C872' }} />}
                        onClick={() => {
                            handleOpen_action();

                            const fullName = surname
                                ? `${name} ${surname}`.trim()
                                : name;

                            setInfo({
                                id,
                                name: fullName,
                                phone,
                                email,
                                gorev,
                                eventType,
                                birim,
                                location,
                                yerZaman,
                                ramakkaladetay,
                                oneri,
                                actionType,
                                actionResult,
                                bonnaUser,
                                datetime,
                                type: "ramakkala"
                            });
                        }}
                    />
                ],
        },
        { field: "name", headerName: "Adı soyadı", minWidth: 150, headerAlign: "center", align: "center", flex: 1, valueGetter: (params) => { const n = params.row.name || ""; const s = params.row.surname || ""; return s ? `${n} ${s}`.trim() : n; } },
        { field: "email", headerName: "E-posta", minWidth: 180, headerAlign: "center", align: "center", flex: 1 },
        { field: "phone", headerName: "Telefon", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
        { field: "gorev", headerName: "Görev", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
        { field: "location", headerName: "Lokasyon", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
        { field: "eventType", headerName: "Tehlikeli Durum / Ramak Kala", minWidth: 180, headerAlign: "center", align: "center", flex: 1 },
        { field: "birim", headerName: "Birim", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
        { field: "yerZaman", headerName: "Yeri / Zamanı", minWidth: 180, headerAlign: "center", align: "center", flex: 1 },
        { field: "ramakkaladetay", headerName: "Tehlikeli Durum & Ramak Kala Detay", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
        { field: "oneri", headerName: "Öneri Açıklama", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
        { field: "datetime", headerName: "Tarih", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
        { field: "bonnaUser", headerName: "Bonna Çalışanı", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
        { field: "actionType", headerName: "Aksiyon Tipi", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
        { field: "actionResult", headerName: "Aksiyon Açıklaması", minWidth: 150, headerAlign: "center", align: "center", flex: 1 },
    ], [])

    const extendedColumns = useMemo(() => [
        
        
        { field: "deviceId", headerName: "Cihaz ID", minWidth: 180, headerAlign: "center", align: "center", flex: 1 },
        { field: "ipAddress", headerName: "IP Adresi", minWidth: 140, headerAlign: "center", align: "center", flex: 1, valueGetter: (params) => params.row.publicIp ?? params.row.ipAddress ?? '' },
        ...getExtraReportColumns(),
    ], [])

    const dataGrid_Columns_resolved = useMemo(
        () => (showExtra ? [...defaultColumns, ...extendedColumns] : defaultColumns),
        [showExtra, defaultColumns, extendedColumns]
    )

    return (
        <div>

            <Box p={3}>


                <DataGrid
                    columns={dataGrid_Columns_resolved}
                    rows={ramakkala}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10,
                            },
                        },
                    }}
                    pageSizeOptions={[10, 25, 50, 75, 100]}
                    slots={{ toolbar: ExcelExportToolbar }}
                    slotProps={{ toolbar: { reportName: 'Ramak_Kala', columns: dataGrid_Columns_resolved, showExtra } }}
                    disableRowSelectionOnClick
                    sx={{
                        boxShadow: 4,
                    }}
                />

                <ActionType_Modal handleClose_action={handleClose_action} open_action={open_action} info={info} setInfo={setInfo} />
                <Delete_Modal info={info} setInfo={setInfo} open_delete={open_delete} handleClose_delete={handleClose_delete} handleOpen_delete={handleOpen_delete} />
            </Box>


        </div>
    )
}

export default RamakKala_Table